import * as React from "react";
import Popover from "@mui/material/Popover";
import { makeStyles } from "@material-ui/core/styles";
import {Close,ArrowDropUp,ArrowDropDown} from '@material-ui/icons'
import Slider from '@mui/material/Slider';
import { Grid, Typography } from "@material-ui/core";
import { connect } from "react-redux";



function PriceRange(props) {
  const [selectedCurrency, setSelectedCurrency] = React.useState(localStorage.getItem('selectedCurrency') ? localStorage.getItem('selectedCurrency') : null);

  const [anchorEl, setAnchorEl] = React.useState(null);

  function valuetext(value) {
    return `${value} ${selectedCurrency}`;
  }

  React.useEffect(() => {
    if (props.vendorCurrency)
      setSelectedCurrency(props.vendorCurrency)
    else setSelectedCurrency(props.currency)
  }, [props.vendorCurrency, props.currency])
  
  function rangetext(arr) {
    return arr? `${arr[0]} ${selectedCurrency} - ${arr[1]} ${selectedCurrency}`:"-";
  }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleUpdate=(e,val)=>{
    handleChange(val);
  }
  const handleChange=(val)=>{
    if(props.onChange)
    props.onChange(val)
  }
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;



 const handleClear=(e)=>{
  e.stopPropagation()
  handleChange(props.defaultValue);
  handleReset();
}
const handleReset=()=>
{
 if(props.onReset)
 props.onReset();
}

  return (
    <div>
       
      <div className="filter-button" onClick={handleClick}>
      <Typography component="span"  className="filter-text">  {props.used? rangetext(props.value):'Price Range'}</Typography>
           {/* {valuetext(flyDuration)}  */}
           <Typography component="span"className="filter-arrow">
            {open?<ArrowDropUp/>:<ArrowDropDown/>}
        </Typography>
        {props.used?   <Typography className="icon-close" variant="a" style={{fontSize:'12px'}} onClick={handleClear}><Close/></Typography>:""}
      
      </div>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        
        <div style={{width:'480px',padding:'30px 25px',backgroundColor:'var(--backgroundcolor)',borderRadius:'5px'}}>
            <Grid container>
                <Grid item xs="6" md="6">
      <Typography component="span" style={{textAlign:'left',color:'var(--darker)'}}>Price Range</Typography></Grid>
      <Grid item xs="6" md="6" style={{textAlign:'right',color:'var(--darker)'}}> <Typography variant="span"  style={{fontSize:'14px'}}> {rangetext(props.priceRange)}</Typography></Grid>
      </Grid>
      <Slider     
      // value={props.value}
        aria-label="Max Fly Duration"
        defaultValue={props.defaultValue}
        getAriaValueText={valuetext}
         step={1}
        // marks
        min={props.minValue ? props.minValue : 0}
        max={props.maxValue ? props.maxValue : 10000} 
        valueLabelDisplay="auto" onChangeCommitted={handleUpdate} 
      />
    </div>
      
      </Popover>
    </div>
  );
}

PriceRange.defaultProps={
  value:[0,100]
}


const mapStateWithProps = (state) => {
  let commissionType = ""
  let commissionValue = 0
  let vendorCurrency;
  if (state.vendor && state.vendor.vendorDetail) {
    commissionType = state.vendor.vendorDetail.commissionType;
    commissionValue = state.vendor.vendorDetail.commissionValue;
    vendorCurrency = state.vendor.vendorDetail.currency;
  }
  let adminCommissionType = "Fixed"
  let adminCommissionValue = 0
  if (state.admin && state.admin.commission && state.admin.commission.commissionType) {
    adminCommissionType = state.admin.commission.commissionType;
    adminCommissionValue = state.admin.commission.commissionValue;
  }
  return {
    auth: state.user.auth,
    userDetails: state.user.userDetails,
    passengers: state.flight.passengers,
    old_passengers: state.flight.old_pass,
    email: state.flight.email,
    phone: state.flight.phone,
    currency: state.flight.currency ? state.flight.currency : "",
    listValid: state.flight.passengerListValid,
    commissionType: commissionType,
    commissionValue: commissionValue,
    vendorCurrency,
    adminCommissionType,
    adminCommissionValue
  }
}

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateWithProps, mapDispatchToProps)(PriceRange);